<template>
  <transition name="slideup">
    <div
      v-if="isOpenStockDialog"
      id="dialog-market"
      class="dialog dialog-item stock-modal"
      :class="{ active: isOpenStockDialog }"
    >
      <div
        class="close-dialog dialog-mask mask"
        data-target="#dialog-market"
        @click.prevent="closeMobileStockDialog"
      />

      <div class="addon-dialog">
        <a
          class="close-dialog r-lightbox__close"
          data-target="#dialog-market"
          @click.prevent="closeMobileStockDialog"
        >
          <i class="icon-dialog-close" />
        </a>
        <div class="addon-dialog-content">
          <div class="addon-item-detail clearfix">
            <div class="addon-item-info stock-item-info">
              <div class="addon-item-order">
                <div>
                  <h3 class="product-title">{{ itemDatas.Name }}</h3>
                </div>
              </div>

              <div class="addon-select-block product-details">
                <div class="color-name-wrap">
                  <div class="product-color">
                    <span class="product-color__current"> COLOR : {{ selectedData.Name }} </span>
                    <ul>
                      <li
                        v-for="(color, index) in itemDatas.Colors"
                        :key="color.ID"
                        class="item-color"
                        :class="{ active: color.ID === selectedData.ID }"
                        @click="changeColor(color.ID, index)"
                      >
                        <a href="javascript:;">
                          <img :src="color.PintSizePictureUrl + '?w=20&h=20'" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="product-color__current">請選擇尺寸</div>
                <ul class="addon-size-wrap">
                  <li
                    v-for="spec in selectedData.Specs"
                    :key="spec.ID"
                    :class="{
                      selected: seletedSize == spec.Barcode,
                      weakSelected: weakSelectedState[spec.Barcode],
                    }"
                    @click="changeSize(spec)"
                  >
                    <div>
                      {{ spec.Name }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- 門市庫存 -->
          <div class="stock-content">
            <div v-if="!dataLoad" class="shop-list">
              <div
                v-if="seletedSize != '' && Object.keys(filterAreaList).length === 0"
                class="no-stock"
              >
                此商品門市暫無庫存
              </div>
              <div v-else class="d-flex">
                列表
                <span v-if="seletedSize != ''">有庫存</span>
              </div>
              <div v-for="(area, key, index) in filterAreaList" :key="index" class="area">
                <div class="area-title">{{ key }}</div>
                <div v-for="(info, id) in area" :key="id" class="area-shop-list">
                  <div class="info">
                    <div class="shop-name">{{ info.Name }}</div>
                    <div>
                      <a class="shop-address" :href="info.MapUrl">
                        {{ info.Address }}
                        <img
                          src="https://static.tpx.tw/sff/pazzo-v2/static/img/location.png"
                          alt=""
                        />
                      </a>
                    </div>
                  </div>
                  <div class="size">
                    {{ selectedSizeName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 門市庫存 -->
          <div class="store-stock">
            <div class="store-stock-tips">
              溫馨提醒
              <br />
              ※ 庫存狀況並非即時狀態，店舖有可能已銷售完畢。
              <br />
              ※ 門市不提供電話或他店訂購及保留的服務。
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import $ from 'jquery';
import { mapState, mapActions, mapMutations } from 'vuex';
import { fireInStoreInventory } from '@global/gtm/product';
import axios from 'axios';

export default {
  name: 'StockMobile',
  props: {
    theProductDataNew: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      areaList: [],
      filterAreaList: {},
      seletedSize: '',
      selectedSizeName: '',
      dataLoad: false,
      weakSelectedState: {},
    };
  },
  computed: {
    ...mapState('shopContent', [
      'selectedData',
      'selectedSpecID',
      'selectedSpecKey',
      'itemDatas',
      'selectedSpec',
      'counter',
      'isOpenStockDialog',
      'selectedDataID',
    ]),
  },
  watch: {
    selectedData: {
      async handler(newValue) {
        const Specs = this.selectedData.Specs.map((e) => e.Barcode);
        await this.getStockData(Specs.join());

        if (newValue.Specs.length === 1) {
          this.changeSize(newValue.Specs[0]);
        }

        if (newValue.Specs.length > 1) {
          for (const e of newValue.Specs) {
            if (e.ID === this.selectedSpecID) {
              this.changeSize(e);
              break;
            }
          }
        }

        this.$nextTick(() => {
          const map = {};
          newValue.Specs.forEach((spec) => {
            map[spec.Barcode] = !this.isSizeWeak(spec.Barcode);
          });
          this.weakSelectedState = map;
        });
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    ...mapActions('shopContent', ['selectSpec', 'changeImg']),
    ...mapMutations('shopContent', ['closeMobileStockDialog']),
    async getStockData(barcode = '') {
      this.dataLoad = true;
      await axios
        .get(API_URL.STOCK, { params: { Barcodes: barcode } })
        .then((res) => {
          this.areaList = [];
          this.areaList = res.data.Response.Branches.map((e) => ({
            ...e,
            Stocks: e.Stocks?.filter((f) => Number(f.Quantity) > 0) || [],
          }));
          this.dataLoad = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeSize(spec) {
      this.filterAreaList = {};
      this.selectSpec(spec);
      this.seletedSize = spec.Barcode;
      this.selectedSizeName = spec.Name;

      const list = this.areaList.filter((e) => {
        return e.Stocks.some((f) => f.Barcode === this.seletedSize);
      });

      this.filterAreaList = list.reduce((acc, e) => {
        if (!acc[e.City]) {
          acc[e.City] = [];
        }
        acc[e.City].push(e);
        return acc;
      }, {});

      const customMarketID = this.itemDatas.CustomMarketID;
      const subStringCustomMarketID = customMarketID.substring(0, customMarketID.indexOf('CL'));
      const itemSpecInfo = `${subStringCustomMarketID}CL${this.selectedData.ID}SZ${this.selectedSpecKey}`;

      const gtmList = list.map((e) => {
        return {
          StoreName: e.Name,
          Size: this.selectedSizeName,
        };
      });
      this.$emit('handleChangeSize', this.seletedSize);

      fireInStoreInventory({
        ProductId: itemSpecInfo,
        ProductName: this.itemDatas.Name,
        HashId: window.Email,
        pColor: this.selectedData.Name,
        pSize: this.selectedSizeName,
        pStoreList: gtmList,
      });
    },
    changeColor(color, index) {
      if (this.selectedData.ID === color) return;
      this.changeImg(color);
      this.filterAreaList = {};
      this.seletedSize = '';
      this.selectedSizeName = '';
      this.$emit('handleChangeColor', index);
    },
    isSizeWeak(barcode) {
      const barcodeList = this.areaList.flatMap((area) => area.Stocks.map((a) => a.Barcode));

      return barcodeList.includes(barcode);
    },
  },
};
</script>
